import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc6b7dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-pool" }
const _hoisted_2 = ["onClick"]

import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { Slide } from '@/types/slides'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutPool',
  emits: ["select"],
  setup(__props, { emit }: { emit: ({
  (event: 'select', payload: Slide): void
}), expose: any, slots: any, attrs: any }) {



const { layouts } = storeToRefs(useSlidesStore())

const selectSlideTemplate = (slide: Slide) => {
  emit('select', slide)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layouts), (slide) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "layout-item",
        key: slide.id,
        onClick: ($event: any) => (selectSlideTemplate(slide))
      }, [
        _createVNode(ThumbnailSlide, {
          class: "thumbnail",
          slide: slide,
          size: 180
        }, null, 8, ["slide"])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})